export enum DirectoryCommonHistoryTypeEnum {
  DIRECTION = 'direction',
  DIRECTION_GROUP = 'direction-group',
  UNIT = 'unit',
  FILIAL = 'filial',
  MASTER_MILESTONE = 'master-milestone',
  DOCUMENT_TYPE = 'document-type',
  OPERATION_TYPE = 'operation-type',
  OPERATION_TYPE_ERP_1C = 'operation-type-erp-1c',
  APPROVAL_SCHEME = 'approval-scheme',
  NOMENCLATURE = 'nomenclature',
  NOMENCLATURE_GROUP = 'nomenclature-group',
  NET_PING_DEVICE = 'net-ping-device'
}
